/**
 * Gemeinsame Härtung für das Rendern von LLM-generiertem Markdown
 * (KIAN-Analysen, Briefings, Chat-Antworten).
 *
 * Schließt den Exfiltrations-Kanal „injizierter Text bringt das Modell dazu,
 * ein externes Bild/`<a href>` mit Daten in der URL einzubetten": Bilder werden
 * gar nicht gerendert, Links nur zu relativen Pfaden bzw. einer Domain-Allowlist
 * (Gegenstück zur Backend-Allowlist in kian/security/outputVerifier.ts).
 */
import { defaultUrlTransform } from 'react-markdown';

const LINK_ALLOWED = /(weclapp\.com|connectwise\.com|\.fixbyte\.|fixbyte\.it|fixbyte\.de|fixbyte\.com|localhost|127\.0\.0\.1)/i;

/** urlTransform für ReactMarkdown: externe URLs außerhalb der Allowlist entfernen. */
export function safeMarkdownUrlTransform(url: string): string {
  const sanitized = defaultUrlTransform(url);
  if (!sanitized) return '';
  if (/^https?:\/\//i.test(sanitized)) {
    return LINK_ALLOWED.test(sanitized) ? sanitized : '';
  }
  // Relative Pfade (/t/…, #anker) und mailto:/tel: bleiben erlaubt
  return sanitized;
}

/** Elemente, die in LLM-Output nie gerendert werden (Bild-GET = Exfil-Kanal). */
export const SAFE_MARKDOWN_DISALLOWED = ['img'] as const;

/** Standard-Props zum Spreaden in <ReactMarkdown {...safeMarkdownProps}>. */
export const safeMarkdownProps = {
  urlTransform: safeMarkdownUrlTransform,
  disallowedElements: [...SAFE_MARKDOWN_DISALLOWED],
  unwrapDisallowed: true,
} as const;
